import { createActions } from "redux-actions";

/**
 * The constants here need to match the related actions. The actions
 * themselves are CONSTANT_CASED, but the related constants are camelCased
 * based on the _, so CONSTANT_CASED becomes constantCased, and something
 * like SOME_DUMB_THING is someDumbThing. Kinda dumb, but w/e.
 */
export const {
    authPostStart,
    authPostSuccess,
    authPostError,
    authPostFinish,

    authWorkforceSignUp,
    authUpdatePortalUser,
} = createActions(
    "AUTH_POST_START",
    "AUTH_POST_SUCCESS",
    "AUTH_POST_ERROR",
    "AUTH_POST_FINISH",

    "AUTH_WORKFORCE_SIGN_UP",
    "AUTH_UPDATE_PORTAL_USER",
);
